import React from 'react';
import './TabNavigation.css';

/**
 * TabNavigation: Componente de navegación entre las pestañas.
 * Permite cambiar entre las vistas de diferentes pestañas.
 * 
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.activeTab - La pestaña activa actual.
 * @param {function} props.setActiveTab - Función para actualizar la pestaña activa.
 * @param {Array} props.tabs - Lista de pestañas con sus etiquetas y valores.
 *   Cada tab puede tener: { label, value, icon } donde icon es opcional (clase de Bootstrap Icons).
 * @returns {JSX.Element} El componente de navegación de pestañas.
 */
function TabNavigation({ activeTab, setActiveTab, tabs }) {
  return (
    <ul className="nav nav-tabs">
      {tabs.map((tab) => (
        <li className="nav-item" key={tab.value}>
          <a
            className={`nav-link ${activeTab === tab.value ? 'active' : ''}`}
            onClick={() => setActiveTab(tab.value)}
          >
            {tab.icon && <i className={`bi ${tab.icon} me-1 tab-icon`}></i>}
            {tab.label}
          </a>
        </li>
      ))}
    </ul>
  );
}

export default TabNavigation;